var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import config from "../../assests/config";
export const tableHeaders = {
    id: {
        value: "Reference #",
        minWidth: 120,
    },
    serviceDate: {
        value: "Date Of Service",
        minWidth: 200,
    },
    memberName: {
        value: "Member Name",
        minWidth: 150,
    },
    providerName: {
        value: "Provider",
        minWidth: 150,
    },
    chargedAmount: {
        value: "Charged Amount",
        minWidth: 150,
    },
    paidAmount: {
        value: "Paid Amount",
        minWidth: 120,
    },
    createdDate: {
        value: "Submitted /Last Edit Date",
        minWidth: 200,
    },
    status: {
        value: "Status",
        minWidth: 200,
    },
    action: {
        value: "Action",
        minWidth: 80,
    },
};
export const headCellsResponsive = [
    { id: 'id', grid: { xs: 5 }, numeric: true, disablePadding: false, label: 'Reference #' },
    { id: 'status', grid: { xs: 5 }, numeric: true, disablePadding: false, label: '' },
    { id: '', grid: { xs: 2 }, numeric: true, disablePadding: false, label: 'action' },
    { id: 'memberName', grid: { xs: 6 }, numeric: false, disablePadding: false, label: 'Member' },
    { id: 'serviceDate', grid: { xs: 6 }, numeric: true, disablePadding: false, label: 'Date Of Service' },
    { id: 'providerName', grid: { xs: 6 }, numeric: false, disablePadding: false, label: 'Provider' },
    { id: 'chargedAmount', grid: { xs: 6 }, numeric: true, disablePadding: false, label: 'Charged Amount' },
    { id: 'paidAmount', grid: { xs: 6 }, numeric: true, disablePadding: false, label: ' Paid Amount' },
    { id: 'createdDate', grid: { xs: 6 }, numeric: true, disablePadding: false, label: 'Submitted /Last Edit Date' },
];
export const headCells = [
    { id: 'id', numeric: true, disablePadding: false, label: 'Reference #' },
    { id: 'serviceDate', numeric: true, disablePadding: false, label: 'Date Of Service' },
    { id: 'memberName', numeric: false, disablePadding: false, label: 'Member' },
    { id: 'providerName', numeric: false, disablePadding: false, label: 'Provider' },
    { id: 'chargedAmount', numeric: true, disablePadding: false, label: 'Charged Amount' },
    { id: 'paidAmount', numeric: true, disablePadding: false, label: ' Paid Amount' },
    { id: 'createdDate', numeric: true, disablePadding: false, label: 'Submitted /Last Edit Date' },
    { id: 'status', numeric: true, disablePadding: false, label: ' Status' },
    { id: '', numeric: true, disablePadding: false, label: 'Action' }
];
const formatDateMonth = new Intl.DateTimeFormat("en-US", { dateStyle: "full" });
export const getReimbursementByMember = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { data: apiResponse } = yield axios.get(config.API_URLS.NETWELL_MY_REIMBURSEMENT_DEV +
            "memberportal/getReimbursementByEmail/" +
            (localStorage.getItem("userMail") || "DarshanaTest@yopmail.com"));
        const keys = Object.keys(tableHeaders);
        let className = {};
        return apiResponse.response.map((data) => {
            return keys.reduce((acc, key) => {
                let modifiedData = data[key];
                if (key === "serviceDate") {
                    modifiedData = formatDateMonth.format(new Date(modifiedData));
                    const findIndex = modifiedData.indexOf(",");
                    modifiedData = modifiedData.slice(findIndex + 2);
                }
                else if (key === "chargedAmount") {
                    modifiedData = modifiedData ? `$${modifiedData}` : "";
                }
                else if (key === "paidAmount") {
                    modifiedData = modifiedData ? `$${modifiedData}` : "";
                }
                else if (key === "createdDate") {
                    modifiedData = formatDateMonth.format(new Date(modifiedData));
                    const findIndex = modifiedData.indexOf(",");
                    modifiedData = modifiedData.slice(findIndex + 2);
                }
                else if (key === "status") {
                    modifiedData =
                        modifiedData === "PENDING" ? "NOT YET SUBMITTED" : modifiedData;
                    className = Object.assign(Object.assign({}, className), { [data.id + "status"]: modifiedData === "NOT YET SUBMITTED"
                            ? "status-pending"
                            : "status-submitted" });
                }
                console.log("3modifiedData: ", className);
                return Object.assign(Object.assign({}, acc), { [key]: modifiedData || "NA", className,
                    data });
            }, {});
        });
    }
    catch (error) {
        return error;
    }
});
